import moment from "moment-timezone";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { isMultipleOfMinRequested } from "../../../../../../../utils/helpers/timeOffRules";

export const useDurationValidations = ({ user, timeOffPlans }) => {
  const { t } = useTranslation();

  const isBiggerThanZero = useCallback((value) => {
    if (value <= 0) {
      return t('duration-bigger-than-zero');
    }
    return null;
  }, [t]);

  const getTimeOffPlan = useCallback((timeSheet, timeOffPlans) => {
    return timeOffPlans?.find((plan) => {
      return (
        plan.startDate <= timeSheet.date
        && plan.endDate >= timeSheet.date
        && plan.plan.payCode === timeSheet.payCode?.id
        // the probation pay code should also be included here
      );
    });
  }, []);

  const hasViolatedTimeOffMinRequestedHours = useCallback((value, timeSheet) => {
    const userTimeOffPlan = getTimeOffPlan(timeSheet, timeOffPlans);
    if (!userTimeOffPlan) {
      return null;
    }

    const duration = moment.duration(value, 'seconds').asHours();
    if (!isMultipleOfMinRequested(userTimeOffPlan.plan, duration)) {
      return t('duration-not-multiple-of-min-requested-hours');
    }

    return null;
  }, [timeOffPlans, user, t]);

  return useMemo(() => {
    return [
      isBiggerThanZero,
      // the maximum hours allowed to be taken is a plan year limit: pay code validations
      hasViolatedTimeOffMinRequestedHours,
    ];
  }, [isBiggerThanZero, hasViolatedTimeOffMinRequestedHours]);
}
